import type React from 'react'

import { useState } from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

import { FeedbackDialog } from '@/components/form/feedback-dialog'

import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog'
import { sanitizeDate } from '@/utils/dates'
import { useUpdateClientProcuracao } from '../services/useUpdateClientProcuracao'

type Props = {
  clientId: string
}

export default function ProcuracaoForm({ clientId }: Props) {
  const [procuracaoHabilitada, setProcuracaoHabilitada] = useState('')
  const [procuracaoHabilitadaEm, setProcuracaoHabilitadaEm] = useState('')
  const [procuracaoValidaAte, setProcuracaoValidaAte] = useState('')
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [message, setMessage] = useState<{
    type: 'success' | 'error'
    text: string
  } | null>(null)
  const { mutate: updateClient } = useUpdateClientProcuracao()
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Replace 'clientId' wit
    //      h the actual client ID variable or prop
    const body = {
      procuracaoHabilitada: procuracaoHabilitada || '',
      procuracaoHabilitadaEm: sanitizeDate(procuracaoHabilitadaEm),
      procuracaoValidaAte: sanitizeDate(procuracaoValidaAte)
    }
    console.log({
      body,
      clientId
    })
    updateClient(
      {
        id_client: clientId, // TODO: replace with actual client ID
        update: body
      },
      {
        onSuccess: () => {
          setMessage({
            type: 'success',
            text: 'O Usuário foi criado com sucesso!'
          })
          setIsDialogOpen(true)
        },
        onError: (error: any) => {
          setMessage({
            type: 'error',
            text: `Houve um erro ao criar o Usuário: ${error.message || 'Erro desconhecido'}`
          })
          setIsDialogOpen(true)
        }
      }
    )
  }

  return (
    <Card className="w-full">
      <CardHeader className="relative">
        <CardTitle>Formulário de Procuração</CardTitle>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="procuracaoHabilitada">Status da Procuração</Label>
            <Select value={procuracaoHabilitada} onValueChange={setProcuracaoHabilitada}>
              <SelectTrigger id="procuracaoHabilitada">
                <SelectValue placeholder="Selecione o status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="HABILITAR PROCURAÇÃO">HABILITAR PROCURAÇÃO</SelectItem>
                <SelectItem value="PROCURAÇÃO HABILITADA">PROCURAÇÃO HABILITADA</SelectItem>
                <SelectItem value="PROCURAÇÃO EXIPRADA">PROCURAÇÃO EXIPRADA</SelectItem>
                <SelectItem value="PROCURAÇÃO CANCELADA">PROCURAÇÃO CANCELADA</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="procuracaoHabilitadaEm">Habilitada Em</Label>
            <input
              id="procuracaoHabilitadaEm"
              type="date"
              value={procuracaoHabilitadaEm}
              onChange={e => setProcuracaoHabilitadaEm(sanitizeDate(e.target.value))}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="procuracaoValidaAte">Válida Até</Label>
            <input
              id="procuracaoValidaAte"
              type="date"
              value={procuracaoValidaAte}
              onChange={e => setProcuracaoValidaAte(sanitizeDate(e.target.value))}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>
        </CardContent>
        <CardFooter>
          <Button type="submit" className="w-full">
            Salvar
          </Button>
        </CardFooter>
      </form>
      <FeedbackDialog isOpen={isDialogOpen} onOpenChange={setIsDialogOpen} message={message} />
    </Card>
  )
}

export function ProcuracaoDialogButton({ clientId }: Props) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="bg-primary text-primary-foreground hover:bg-primary-hover ">Atualizar Procuração</Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <ProcuracaoForm clientId={clientId} />
      </DialogContent>
    </Dialog>
  )
}
